
        import 'PlanDetails.5c26a89.css-module'
        export default {"PlanDetails":"PlanDetails_PlanDetails_5c26a89"}
    